import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { RegionService } from 'src/app/services/region.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { ServiceScheduleService } from 'src/app/services/serviceschedule.service';
import { TargetService } from 'src/app/services/target.service';
import { ConsumableentryComponent } from './consumableentry.component';
import { ConsummableService } from 'src/app/services/consumables.service';

@Component({
  selector: 'app-consumableentrydialog',
  templateUrl: './consumableentrydialog.component.html',
  styleUrls: ['./consumableentrydialog.component.scss'],

})
export class ConsumableentrydialogComponent implements OnInit {

  id = 0;
  actionInfo = 0;
  mhireLogBook=0;
  form: FormGroup;
  routeParams: any;
  pageTitle: string;
  data: any;
  submitbtn: string;
  filesResult: any;
  //selectedImage: any;
  licenceTypeList: any[];
  selectedFileName = 'Choose File';
  dropdownSettings: any = {};
  vehicleList: any = [];
  formEditMode = true;
  Languages: any[];
  RollList: any;
  passworderror = false;
  isReadOnly = false;
  // isDisable: boolean;
  isDisable = false;
  pattern: RegExp;
  show: boolean;
  show2: boolean;
  clientId: any;
  emailpattern: RegExp;
  registrationNumbers: any[];
  filterRegistrationNumbers: any[];
  regionList: any[];
  filterregionList: any[];
  divisionList: any[];
  filterListdivision: any[];
  filterListSubdivision: any[];
  subdivisionList: any[];
  uomTypeName: any;
  getUomTypeList: any[];
  filterUomTypeList: any[];
  FinancialYearList: any[];
  filterFinancialYearList: any[];
  serviceArray: any;
  itemTypeList: any[];
  filteritemTypeList: any[];
  consumableList: any[];
  filterconsumableList: any[];
  others: boolean;
  unitTypeN: boolean;
  repairchargesvali:boolean = true;
  validateremarks: boolean;
  conspareothers: boolean;
  unitypeName: any;
  consumableName: any;
  submitBtnTxt: string;
  submitBtn: boolean;
  unitype: any;
  quantityTypeName: any;
  quantityType: any;
  fileType: number;
  attachmentViewModel: { id: number; attachmentFilename: any; attachmentType: number; fileType: number; base64String: any; statusType: number; };
  consspareName: string = 'Consumable Type';
 


  constructor(public dialogRef: MatDialogRef<ConsumableentryComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,
    private formBuilder: FormBuilder,
    private _location: Location,
    route: ActivatedRoute,
    public dialog: MatDialog,
    private alertService: AlertService,
    private userSessionService: UserSessionService,
    private regionService: RegionService,
    private translate: TranslateService,
    private vehicleService: VehicleService,
    private divisionService: DivisionService,
    private subdivisionService: SubDivisionService,
    private serviceScheduleService: ServiceScheduleService,
    private targetService: TargetService,
    private consummableService: ConsummableService) {
    this.routeParams = route.snapshot.params;
    this.id = this.dataRecievedToEdit.formData.id ? this.dataRecievedToEdit.formData.id : this.dataRecievedToEdit.formData.consid;
    this.actionInfo = this.dataRecievedToEdit.actionInfo;
    this.mhireLogBook=this.dataRecievedToEdit.mhireLogBook
    if (this.id === 0) {
      this.submitbtn = 'Save';
    } else {
      this.submitbtn = 'Update';
    }
    if (this.actionInfo == 1) {
      this.formEditMode = false
    }
    this.pattern = /^[^\s]+(\s+[^\s]+)*$/;
    this.emailpattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.registrationNumbers = [];
    this.filterRegistrationNumbers = [];
    this.regionList = [];
    this.filterregionList = [];
    this.divisionList = [];
    this.filterListdivision = [];
    this.subdivisionList = [];
    this.filterListSubdivision = [];
    this.getUomTypeList = [];
    this.filterUomTypeList = [];
    this.FinancialYearList = [];
    this.filterFinancialYearList = [];
    this.itemTypeList = [];
    this.filteritemTypeList = [];
    this.consumableList = [];
    this.filterconsumableList = [];
    this.serviceArray = [];
  }

  ngOnInit() {
    this.initializeValidators();
   // this.get(true);
    // this.getLookupRegion(true);
    this.getUomType();
    this.getFileToEdit(this.dataRecievedToEdit);
    this.getItemType();
    // this.getconsumables(true);
   if(this.id == 0){
    this.form.controls["others"].setValidators(Validators.required);
    this.form.controls["others"].updateValueAndValidity();
   }
  }

  //   chosenYearHandler( normalizedYear: Moment ) {
  //     const ctrlValue = this.dateTime.value;
  //     ctrlValue.year(normalizedYear.year());
  //     this.dateTime.setValue(ctrlValue);
  // }

  // chosenMonthHandler( normalizedMonth: Moment, datepicker: OwlDateTimeComponent<Moment> ) {
  //     const ctrlValue = this.dateTime.value;
  //     ctrlValue.month(normalizedMonth.month());
  //     this.dateTime.setValue(ctrlValue);
  //     datepicker.close();
  // }
  initializeValidators() {
    this.form = this.formBuilder.group({
      id: [0],
      itemType: [null, [Validators.required]],
      spareConsumableId: [null],
      quantity: [null, [Validators.required]],
      quantityType: [null],
      others: [null],
      totalCost: [null, [Validators.required]],
      statusType:[1],
      itemTypeName:[null],
      vehicleConsumableId:[this.id],
      consumableName:[null],
      userPhoto:[null],
      userPhotoPath:[null],
      fileType:[null],
      quantityTypeName:[null],
      idbNo:[null, [Validators.required]],
      remarks:[null],
    });
  }

  get(refresh: boolean) {
    if (this.id > 0) {
      this.targetService.getById(this.id, refresh).subscribe(result => {
        this.data = result;
        if (this.data) {
          this.form.patchValue(this.data);
          if (this.formEditMode === false) {
            this.isReadOnly = false;
            this.form.disable();
            this.isDisable = true;
            //this.isReadOnly = false;
          }
        }
      });
      this.isReadOnly = true;
    }
  }
  getUomType() {
    this.consummableService.getQuantitytype(true).subscribe(res => {
      if (res) {
        this.getUomTypeList = [];
        this.filterUomTypeList = [];
        this.getUomTypeList = res;
        this.filterUomTypeList = this.getUomTypeList.slice();
      }
    });
  }
  umoTypeChange(){
    const unitypeName =  this.getUomTypeList.filter(e=>{
       return e.key === this.form.value.quantityType
     })
     this.consumableName = unitypeName[0].value;
     this.form.controls["consumableName"].setValue(this.consumableName);
     this.form.controls["quantityTypeName"].setValue(this.consumableName);
   }
  getItemType() {
    this.consummableService.getItemType(true).subscribe(res => {
      if (res) {
        this.itemTypeList = [];
        this.filteritemTypeList = [];
        this.itemTypeList = res;
        this.filteritemTypeList = this.itemTypeList.slice();
      }
    });
  }

  


  ConsumableTypeChange() {
    if(this.form.value.itemType === 1){
      this.consspareName = 'Spare';
      this.getconsumables(true);
      this.others = true;
      this.unitTypeN = true;
      this.conspareothers = false;
      this.repairchargesvali = true
      this.form.controls["idbNo"].setValidators(Validators.required);
      this.form.controls["idbNo"].updateValueAndValidity();
      this.form.controls["others"].setValidators(Validators.required);
      this.form.controls["others"].updateValueAndValidity();
      // this.form.controls["spareConsumableId"].clearValidators();
      // this.form.controls["spareConsumableId"].updateValueAndValidity();
      this.form.controls["quantityType"].setValidators(Validators.required);
      this.form.controls["quantityType"].updateValueAndValidity();
      this.form.controls["consumableName"].clearValidators();
      this.form.controls["consumableName"].updateValueAndValidity();
      if (this.form.value.spareConsumableId) { this.form.controls['spareConsumableId'].setValue(null);}
      if (this.form.value.others) { this.form.controls['others'].setValue(null);}
      if (this.form.value.quantity) { this.form.controls['quantity'].setValue(null);}
      if (this.form.value.quantityType) { this.form.controls['quantityType'].setValue(null);}
      if (this.form.value.totalCost) { this.form.controls['totalCost'].setValue(null);}
      if (this.form.value.idbNo) { this.form.controls['idbNo'].setValue(null);}
      if (this.form.value.remarks) { this.form.controls['remarks'].setValue(null);}
      
    }
    if(this.form.value.itemType === 2){
      this.consspareName = 'Consumable';
      this.getconsumables(true);
      this.others = false;
      this.unitTypeN = true;
      this.repairchargesvali = true
      this.form.controls["idbNo"].setValidators(Validators.required);
      this.form.controls["idbNo"].updateValueAndValidity();
      this.form.controls["spareConsumableId"].setValidators(Validators.required);
      this.form.controls["spareConsumableId"].updateValueAndValidity();
      // this.form.controls["others"].clearValidators();
      // this.form.controls["others"].updateValueAndValidity();
      this.unitTypeN = true;
      this.form.controls["others"].setValidators(Validators.required);
      this.form.controls["others"].updateValueAndValidity();

      this.form.controls["quantityType"].setValidators(Validators.required);
      this.form.controls["quantityType"].updateValueAndValidity();
      this.form.controls["consumableName"].setValidators(Validators.required);
      this.form.controls["consumableName"].updateValueAndValidity();
      if (this.form.value.spareConsumableId) { this.form.controls['spareConsumableId'].setValue(null);}
      if (this.form.value.others) { this.form.controls['others'].setValue(null);}
      if (this.form.value.quantity) { this.form.controls['quantity'].setValue(null);}
      if (this.form.value.quantityType) { this.form.controls['quantityType'].setValue(null);}
      if (this.form.value.totalCost) { this.form.controls['totalCost'].setValue(null);}
      if (this.form.value.idbNo) { this.form.controls['idbNo'].setValue(null);}
      if (this.form.value.remarks) { this.form.controls['remarks'].setValue(null);}
    }
    if(this.form.value.itemType === 3){
      this.consspareName = 'Repair Charges';
      this.quantityTypeName = ''
      this.form.controls["quantityType"].setValue(0);
      this.others = true;
      this.unitTypeN = false;
      this.conspareothers = false;
      this.form.controls["others"].setValidators(Validators.required);
      this.form.controls["others"].updateValueAndValidity();
      // this.form.controls["spareConsumableId"].clearValidators();
      // this.form.controls["spareConsumableId"].updateValueAndValidity();
      this.form.controls["quantityType"].clearValidators();
      this.form.controls["quantityType"].updateValueAndValidity();
      this.form.controls["consumableName"].clearValidators();
      this.form.controls["consumableName"].updateValueAndValidity();
      this.form.controls["idbNo"].clearValidators();
      this.form.controls["idbNo"].updateValueAndValidity();
      this.repairchargesvali = false
      if (this.form.value.spareConsumableId) { this.form.controls['spareConsumableId'].setValue(null);}
      if (this.form.value.others) { this.form.controls['others'].setValue(null);}
      if (this.form.value.quantity) { this.form.controls['quantity'].setValue(null);}
      if (this.form.value.quantityType) { this.form.controls['quantityType'].setValue(null);}
      if (this.form.value.totalCost) { this.form.controls['totalCost'].setValue(null);}
      if (this.form.value.idbNo) { this.form.controls['idbNo'].setValue(null);}
      if (this.form.value.remarks) { this.form.controls['remarks'].setValue(null);}
    }
    if(this.form.value.itemType === 6){

      this.consspareName = 'Others';
      this.quantityTypeName = ''
      // this.form.controls["quantityType"].setValue(0);
      this.getconsumables(true);
      this.others = true;
      this.unitTypeN = true;
      this.conspareothers = false;
      this.repairchargesvali = true
      this.form.controls["idbNo"].setValidators(Validators.required);
      this.form.controls["idbNo"].updateValueAndValidity();
      this.form.controls["others"].setValidators(Validators.required);
      this.form.controls["others"].updateValueAndValidity();
      // this.form.controls["spareConsumableId"].clearValidators();
      // this.form.controls["spareConsumableId"].updateValueAndValidity();
      this.form.controls["quantityType"].setValidators(Validators.required);
      this.form.controls["quantityType"].updateValueAndValidity();
      this.form.controls["consumableName"].clearValidators();
      this.form.controls["consumableName"].updateValueAndValidity();
      if (this.form.value.spareConsumableId) { this.form.controls['spareConsumableId'].setValue(null);}
      if (this.form.value.others) { this.form.controls['others'].setValue(null);}
      if (this.form.value.quantity) { this.form.controls['quantity'].setValue(null);}
      if (this.form.value.quantityType) { this.form.controls['quantityType'].setValue(null);}
      if (this.form.value.totalCost) { this.form.controls['totalCost'].setValue(null);}
      if (this.form.value.idbNo) { this.form.controls['idbNo'].setValue(null);}
      if (this.form.value.remarks) { this.form.controls['remarks'].setValue(null);}

    }

    if(this.form.value.itemType === 4){

      this.consspareName = 'Tyre Detail';
      this.quantityTypeName = ''
      // this.form.controls["quantityType"].setValue(0);
      this.getconsumables(true);
      this.others = true;
      this.unitTypeN = true;
      this.conspareothers = false;
      this.repairchargesvali = true
      this.form.controls["idbNo"].setValidators(Validators.required);
      this.form.controls["idbNo"].updateValueAndValidity();
      this.form.controls["others"].setValidators(Validators.required);
      this.form.controls["others"].updateValueAndValidity();
      // this.form.controls["spareConsumableId"].clearValidators();
      // this.form.controls["spareConsumableId"].updateValueAndValidity();
      this.form.controls["quantityType"].setValidators(Validators.required);
      this.form.controls["quantityType"].updateValueAndValidity();
      this.form.controls["consumableName"].clearValidators();
      this.form.controls["consumableName"].updateValueAndValidity();
      if (this.form.value.spareConsumableId) { this.form.controls['spareConsumableId'].setValue(null);}
      if (this.form.value.others) { this.form.controls['others'].setValue(null);}
      if (this.form.value.quantity) { this.form.controls['quantity'].setValue(null);}
      if (this.form.value.quantityType) { this.form.controls['quantityType'].setValue(null);}
      if (this.form.value.totalCost) { this.form.controls['totalCost'].setValue(null);}
      if (this.form.value.idbNo) { this.form.controls['idbNo'].setValue(null);}
      if (this.form.value.remarks) { this.form.controls['remarks'].setValue(null);}
     
    }

    if(this.form.value.itemType === 5){

      this.consspareName = 'Battery Serial Number & Detail';
      this.quantityTypeName = ''
      // this.form.controls["quantityType"].setValue(0);
      this.getconsumables(true);
      this.others = true;
      this.unitTypeN = true;
      this.conspareothers = false;
      this.repairchargesvali = true
      this.form.controls["idbNo"].setValidators(Validators.required);
      this.form.controls["idbNo"].updateValueAndValidity();
      this.form.controls["others"].setValidators(Validators.required);
      this.form.controls["others"].updateValueAndValidity();
      // this.form.controls["spareConsumableId"].clearValidators();
      // this.form.controls["spareConsumableId"].updateValueAndValidity();
      this.form.controls["quantityType"].setValidators(Validators.required);
      this.form.controls["quantityType"].updateValueAndValidity();
      this.form.controls["consumableName"].clearValidators();
      this.form.controls["consumableName"].updateValueAndValidity();
      if (this.form.value.spareConsumableId) { this.form.controls['spareConsumableId'].setValue(null);}
      if (this.form.value.others) { this.form.controls['others'].setValue(null);}
      if (this.form.value.quantity) { this.form.controls['quantity'].setValue(null);}
      if (this.form.value.quantityType) { this.form.controls['quantityType'].setValue(null);}
      if (this.form.value.totalCost) { this.form.controls['totalCost'].setValue(null);}
      if (this.form.value.idbNo) { this.form.controls['idbNo'].setValue(null);}
      if (this.form.value.remarks) { this.form.controls['remarks'].setValue(null);}
    }



    
    const itemTypeName = this.itemTypeList.filter(e=>{
      return e.key === this.form.value.itemType;
    })
    this.form.controls["itemTypeName"].setValue(itemTypeName[0].value);
    
  }
  getconsumables(refresh: boolean) {
    
    this.consummableService.get(refresh).subscribe(result => {
      this.consumableList = [];
      this.filterconsumableList = [];
      //  this.consumableList = result;
      this.consumableList = result.filter(e => {
        return e.itemType === this.form.value.itemType;
      })
      this.filterconsumableList = this.consumableList.slice();
      // const consumableList = this.consumableList.length;
      //   if (consumableList === 1) {
      //     this.form.controls['spareConsumableId'].setValue(this.consumableList[0].id);
      //     this. ConsumableNameChange();
      //   }
    
    
    });
  }
  ConsumableNameChange(){
   const unitypeName =  this.consumableList.filter(e=>{
      return e.id === this.form.value.spareConsumableId
    })

    if(unitypeName[0].name == "Others"){
      // this.others = true;
      this.unitTypeN = false;
      this.conspareothers = true;
      this.validateremarks = true;
      this.consumableName = unitypeName[0].name;
      this.form.controls["consumableName"].setValue(this.consumableName);
      this.form.controls["quantityType"].setValue(0);
      this.form.controls["remarks"].setValidators(Validators.required);
      this.form.controls["remarks"].updateValueAndValidity();
      this.form.controls["others"].clearValidators();
      this.form.controls["others"].updateValueAndValidity();
    }
    else{

          //this.unitypeName = unitypeName[0].quantityTypeName;
          this.unitTypeN = true;
          this.conspareothers = false;
    this.quantityTypeName = unitypeName[0].quantityTypeName;
    this.quantityType = unitypeName[0].quantityType;
    this.consumableName = unitypeName[0].name;
    // this.form.controls["quantityType"].setValue(this.quantityType);
    this.form.controls["consumableName"].setValue(this.consumableName);
        this.form.controls["others"].clearValidators();
      this.form.controls["others"].updateValueAndValidity();
      this.form.controls['others'].setValue('');
      this.form.controls["remarks"].clearValidators();
      this.form.controls["remarks"].updateValueAndValidity();
      this.validateremarks = false;

    }


  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  onSubmit() {
    if(this.form.value.itemType === 1 || this.form.value.itemType === 2 ){
      // this.form.controls['others'].setValue('');
      // this.form.controls['spareConsumableId'].setValue(null);
    }
    if(this.form.value.itemType === 3 || this.form.value.itemType === 4 ){
      this.form.controls['spareConsumableId'].setValue(null);
      this.form.controls['consumableName'].setValue(null);
    }
    if(!this.form.value.quantity){
      this.form.controls['quantity'].setValue(null);
    }
    if(this.actionInfo==2){
      this.form.controls["idbNo"].clearValidators();
      this.form.controls["idbNo"].updateValueAndValidity();
    }
    if (this.form.valid) {
      this.form.controls['fileType'].setValue(this.fileType);
      this.form.value.attachmentViewModel = this.attachmentViewModel;
      this.serviceArray.push(this.form.value);
      this.dialogRef.close(this.serviceArray);
      this.alertService.success('Spare / Consumable Name Saved Successfully');
    } else {
      this.validateFormControl();
    }
  }

  onCancel(isProceed) {
    this.dialogRef.close(isProceed);
  }

  close(isProceed) {
    this.dialogRef.close(isProceed);
  }

  getFileToEdit(data: any) {
    
    if(data && data.formData){
      data.formData
      this.others = data.formData && data.formData.spareConsumableId ? false:true;
    }
    if (data && data.actionInfo == 0 && this.id !== 0) {
      this.submitBtnTxt = "Update"
      this.form.updateValueAndValidity();
      this.form.patchValue(data.formData);
      this.getconsumables(true);
      this.consummableService.get(true).subscribe(result => {
        this.consumableList = [];
        this.consumableList = result
        const unitypeName =  this.consumableList.filter(e=>{
          return e.id === this.form.value.spareConsumableId
        }) 
        this.quantityTypeName = unitypeName[0].quantityTypeName;
      });
    
      if(data.formData.attachmentViewModel){
        this.attachmentViewModel = data.formData.attachmentViewModel
      this.filesResult = this.attachmentViewModel.base64String;
        this.fileType =  this.attachmentViewModel.fileType;
    }
    }
    if (data && data.actionInfo == 1 && this.id !== 0) {
      this.submitBtn = false;
      this.form.disable();
      this.form.updateValueAndValidity();
      this.getconsumables(true);
      this.form.patchValue(data.formData);
      this.consummableService.get(true).subscribe(result => {
        this.consumableList = [];
        this.consumableList = result
        const unitypeName =  this.consumableList.filter(e=>{
          return e.id === this.form.value.spareConsumableId
        }) 
        this.quantityTypeName = unitypeName[0].quantityTypeName;
      });
      if(data.formData.attachmentViewModel){
        this.attachmentViewModel = data.formData.attachmentViewModel
      this.filesResult = this.attachmentViewModel.base64String;
        this.fileType =  this.attachmentViewModel.fileType;
    }
    }
    if(this.form.value.itemType === 1){
      this.consspareName = 'Spare';
      this.unitTypeN = true;
    }
    if(this.form.value.itemType === 2){
      this.consspareName = 'Consumable';
      this.unitTypeN = true;
    }
    if(this.form.value.itemType === 3){
      this.consspareName = 'Repair Charges';
      this.unitTypeN = false;
      this.form.controls["idbNo"].clearValidators();
      this.form.controls["idbNo"].updateValueAndValidity();
      this.repairchargesvali = false
    }
    if(this.form.value.itemType === 6){
      this.consspareName = 'Others';
      this.unitTypeN = true;
    }

    if(this.form.value.itemType === 4){
      this.consspareName = 'Tyre Detail';
      this.unitTypeN = true;
    }

    if(this.form.value.itemType === 5){
      this.consspareName = 'Battery Serial Number & Detail';
      this.unitTypeN = true;
    }

    if(this.form.value.consumableName == "Others"){
      this.unitTypeN = false;
      this.conspareothers = true;
      this.others = false;


    }

    // this.ConsumableNameChange();
  }


  onFileSelected(event1) {
    const file = event1.target.files[0];
    let ext = file.name.split('.').pop();
    if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') || ext === 'pdf') {
      if(ext !== 'pdf'){
        this.fileType = 1;
      }else{
        this.fileType = 2;
      }
      this.selectedFileName = file.name;
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize < 5000) {
        if (event1.target.files && event1.target.files[0]) {
          const reader = new FileReader();
          reader.readAsDataURL(event1.target.files[0]);
          reader.onload = (event: any) => {
            this.filesResult = event.target.result.split(',')[1];
            if (this.filesResult) {
              // this.selectedImage = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,'
              // + this.filesResult);
               this.form.controls['userPhoto'].setValue(this.filesResult);
               this.form.controls['userPhotoPath'].setValue(this.filesResult ? this.selectedFileName : ''); // <-- Set Value for Validation
               this.attachmentViewModel ={
                id: 0,
                attachmentFilename: this.selectedFileName,
                attachmentType: 7,
                fileType:  this.fileType,
                base64String: this.filesResult,
                statusType: 2
              }
             
             
             
               // if (this.uploadData && this.uploadData.length < 4) {
              //   this.uploadData.push({
              //     id: 0,
              //     attachmentPath: "string",
              //     attachmentFilename: this.selectedFileName,
              //     attachmentType:this.form.value.attachmentType_Id,
              //     attachmentTypeName: this.attachmentName,
              //     base64String: this.filesResult,
              //     statusType: 2
              //   });
              //   this.attachmentsDataSource = new MatTableDataSource(this.uploadData);
              // } else {
              //   //this.alertService.warning('Maxximum four files only allowed');
              // }
             // this.imgerr = false;
             
            }
          }
        }
      } else {
        this.alertService.error('File size is large');
        this.selectedFileName = '';
      }

    } else {
      this.alertService.error('Please upload PDF, JPG & PNG images');
    }
  }
}
